export class State {
  stateId!: number;
  stateName!: string;
  constructor(source: Partial<State>) {
    Object.assign(this, source);
  }
}
